<template>
  <div v-if="!hideFooter">
<!--   <RichText-->
<!--     v-if="navigationGroups.length > 0 && homepageItem"-->
<!--     :value="homepageItem.elements.footerContentBlock.value"-->
<!--   />-->
    <ContactBlock
      v-if="showGlobalContentBlockState"
      v-for="cb in globalContactBlocks"
      :model="cb"
      :use-site-store="isSiteStore"
      :home-page-id="homePageId"
    />

    <!-- Global Footer -->
    <div class="global-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="footer-copyright">
              <img class="logo" :src="getLogoSrc()" :alt="getLogoDescription()" />
              <span v-html="text"></span>
            </div>
          </div>
          <div class="col-lg-4">
            <ul class="navbar-nav ms-auto footer-links">
              <template v-for="(item, index) in navigationItems" :key="index">
                <li class="nav-item" v-if="item.subItems.length == 0">
                  <MyLink :to="item.url" class="nav-link" exact-active-class="active">
                    {{ item.title }}</MyLink
                  >
                </li>
                <li class="nav-item dropdown" v-if="item.subItems.length > 0">
                  <a
                    class="nav-link dropdown-toggle"
                    href="/"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    >{{ item.title }}
                    <font-awesome class="icon-caret" icon="chevron-down" />
                  </a>
                  <ul class="dropdown-menu">
                    <li v-for="subItem in item.subItems">
                      <MyLink
                        :external="true"
                        class="dropdown-item"
                        :to="subItem.url"
                        exact-active-class="active"
                      >
                        {{ subItem.title }}</MyLink
                      >
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContactBlockModel } from '~/models'

const siteStore = useSiteStore()
const siteCfg = siteStore.siteConfig
const logo = firstOrDefault(siteCfg.elements.websiteLogo.value)
const hideFooter = ref(multipleChoiceToBoolean(siteCfg.elements.hideFooter))
const textOverwrite = ref(siteCfg.elements.footerTextOverwrite.value)

const isSiteStore = ref<boolean>(true)
const homePageId = ref<string | undefined>()

const text = computed(() => {
  if (textOverwrite.value) {
    return textOverwrite.value
  }

  return `&copy; ${new Date().getFullYear()} JND Legal Administration. All rights reserved.`
})

const showGlobalContentBlockState = useState<boolean>('showGlobalContentBlockState')

const { homepageItem} = useNavigationGroup()
const navigationItems = siteStore.getFooterNavigationItems();

const globalContactBlocks = computed<ContactBlockModel[]>(() => {
  const footerBlocks =
    homepageItem.value?.elements?.footerContactBlock?.value ?? []

  if (footerBlocks.length > 0) {
    return siteStore.getListAs<ContactBlockModel>(footerBlocks)
  }

  return siteStore.getListAs<ContactBlockModel>(
    siteCfg.elements.globalContactBlock.value
  )
})

watchEffect(() => {
  const footerBlocks =
    homepageItem.value?.elements?.footerContactBlock?.value ?? []

  if (footerBlocks.length > 0) {
    isSiteStore.value = false
    homePageId.value = homepageItem.value?.system.id
  } else {
    isSiteStore.value = true
    homePageId.value = undefined
  }
})

function getLogoSrc() {
  if (logo) {
    return logo?.url
  }

  return 'logo-jnd.png'
}

function getLogoDescription() {
  if (logo) {
    return logo.description || 'JND Logo'
  }

  return 'JND Logo'
}
</script>
